<template>
  <div class="table-container">
    <img v-if="showLinkBanner" src="../../../assets/image/banner.jpg" class="link-banner">
    <div class="table-box">
      <div class="title-box table-item">
        <p class="title">基本信息</p>
      </div>
      <div class="table-line flex">
        <div class="table-item">
          <div class="label">
            <p class="text">姓名：</p>
          </div>
          <div class="content">{{ list[0].name }}</div>
        </div>
        <div class="table-item">
          <div class="label">
            <p class="text">性别：</p>
          </div>
          <div class="content">{{ list[0].sex === 1 ? '男' : '女' }}</div>
        </div>
      </div>
      <div class="table-line flex">
        <div class="table-item">
          <div class="label">
            <p class="text">身份证号：</p>
          </div>
          <div class="content">{{ list[0].idCard }}</div>
        </div>
        <div class="table-item">
          <div class="label">
            <p class="text"></p>
          </div>
          <div class="content"></div>
        </div>
      </div>

    </div>
    <div
      class="table-box"
      v-for="(item, ind) in list"
      :key="ind">
      <div class="title-box table-item">
        <p class="title">证书信息</p>
      </div>
      <div class="table-line flex">
        <div class="table-item">
          <div class="label">
            <p class="text">专业岗位名称：</p>
          </div>
          <div class="content">{{ item.majorName }}</div>
        </div>
        <div class="table-item">
          <div class="label">
            <p class="text">学时：</p>
          </div>
          <div class="content">{{ item.period}}</div>
        </div>
      </div>
      <div class="table-line flex">
        <div class="table-item">
          <div class="label">
            <p class="text">操作技能成绩：</p>
          </div>
          <div class="content">{{ item.operation}}</div>
        </div>
        <div class="table-item">
          <div class="label">
            <p class="text">理论知识成绩：</p>
          </div>
          <div class="content">{{ item.theory}}</div>
        </div>
      </div>
      <div class="table-line flex">
        <div class="table-item">
          <div class="label">
            <p class="text">综合评定成绩：</p>
          </div>
          <div class="content">{{ item.synthesize }}</div>
        </div>
        <div class="table-item">
          <div class="label">
            <p class="text">证书编号：</p>
          </div>
          <div class="content">{{ item.qualifyNumber }}</div>
        </div>
      </div>
      <div class="table-line flex online border">
        <div class="table-item">
          <div class="label">
            <p class="text">发证日期：</p>
          </div>
          <div class="content">{{ item.qualifyTime | formatDate }}</div>
        </div>
      </div>
      <div class="table-line flex online">
        <div class="table-item">
          <div class="label">
            <p class="text">发证单位：</p>
          </div>
          <div class="content">{{ item.issuingAuthority }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array
    }
  },
  data() {
    return {
    }
  },
  computed: {
    showLinkBanner () {
      if (this.list && this.list.length !== 0) {
        const v = this.list.some(item => ['合格', '优秀', '良好'].includes(item.synthesize))
        return v
      }
      return false
    }
  },
  filters: {
    formatDate (val) {
      if (val) {
        return val.split(' ')[0]
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.table-container {
  max-width: 980px;
  margin: 30px auto;
  .link-banner {
    width: 970px;
    height: auto;
  }
  .border {
    border-bottom: 1px solid #AEAEAE;
  }
  .flex {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .table-box {
    max-width: 970px;
    height: auto;
    border: 1px solid #AEAEAE;
    border-top: none;
    box-sizing: border-box;
    border-right: none;
    .table-item {
      width: 100%;
      height: 50px;
      line-height: 50px;
      display: flex;
      flex-direction: row;
      align-items: center;
      .label {
        width: 225px;
        height: 50px;
        text-align: right;
        border-right: 1px solid #AEAEAE;
        border-bottom: 1px solid #AEAEAE;
        padding-right: 20px;
        background: linear-gradient(90deg, rgba(80, 124, 247, .1) 100%);
        box-sizing: border-box;
        .text {
          color: #333;
        }
      }
      .content {
        width: 259px;
        height: 50px;
        padding: 0 20px;
        border-right: 1px solid #AEAEAE;
        border-bottom: 1px solid #AEAEAE;
        box-sizing: border-box;
        white-space: nowrap;
      }
    }
    .title-box {
      width: 100%;
      color: #fff;
      font-size: 16px;
      font-weight: bold;
      background: linear-gradient(90deg, #0751B5 0%, #507CF7 100%);
      padding: 0 30px;
      box-sizing: border-box;
      .title {
        &::before {
          content: '·';
          display: inline-block;
          font-size: 20px;
          color: #fff;
          line-height: 50px;
          margin-right: 5px;
        }
      }
    }
    .online {
      width: 100%;
      .label {
        width: 225px;
        border-bottom: none;
      }
      .content {
        width: 100%;
        max-width: 743px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        border-bottom: none;
      }
    }
  }
}
</style>
